import axios from "axios";

export const callExternalApi = async (options, version = 1) => {
  if (version === 2) {
    return callExternalApi_v2(options);
  }
  try {
    const response = await axios(options.config);
    const { data } = response;

    return {
      data,
      error: null,
    };
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error;

      const { response } = axiosError;
      const responseData = response?.data;

      let message = "http request failed";

      if (response && response.statusText) {
        message = response.statusText;
      }

      if (axiosError.message) {
        message = axiosError.message;
      }

      if (responseData && responseData.message) {
        message = responseData.message;
      }

      // Handle ASP.NET ProblemDetails and model-state errors.
      if (responseData && responseData.title) {
        message = responseData.title;
      }

      if (responseData && responseData.errors && typeof responseData.errors === "object") {
        const modelErrors = Object.values(responseData.errors)
          .flat()
          .filter(Boolean)
          .join(" | ");

        if (modelErrors) {
          message = modelErrors;
        }
      }

      return {
        data: null,
        error: {
          message,
        },
      };
    }

    return {
      data: null,
      error: {
        message: error.message,
      },
    };
  }
};

export const callExternalApi_v2 = async (options) => {
  const response = await axios(options.config);
  const { data } = response;
  return data;
};